import { Alert } from './Alert';
import { BoxArrowRow, BoxCorner } from './Box';
import { Carousel } from './Carousel';
import { CollectionHeader } from './Collection';
import { Completer, CompleterNotification } from './Completer';
import { CurrentDay } from './CurrentDay';
import { DividerHr, DividerZigZag } from './Dividers';
import { Exercise, ExerciseSet } from './Exercise';
import { FavouriteButton, FavouriteNoResult } from './Favourite';
import { FooterDashboard, FooterMain } from './Footer';
import { FormFeedback } from './FormFeedback';
import { FormLogin } from './FormLogin';
import { FormResetPassword } from './FormResetPassword';
import { FormReview } from './FormReview';
import { ImageCircle, ImageBackground } from './Image';
import { Modal, ModalUpgrade, ModalPopup } from './Modal';
import { NutritionBmi, NutritionInformation } from './Nutrition';
import { PaginationRow } from './Pagination';
import { ProgressBadge, ProgressBar } from './Progress';
import { RatingStars } from './RatingStars';
import { Review, ReviewReply } from './Review';
import { ScrollTopOnChange } from './ScrollTopOnChange';
import { Spinner } from './Spinner';
import { TermsConditions } from './TermsConditions';
import { CreditCardNumber, CreditCardDate } from './Validators';

import {
  ButtonBack,
  ButtonBlock,
  ButtonFullWidth,
  ButtonLink,
  ButtonPlay,
  ButtonPrimary,
  ButtonPrint,
} from './Button';

import {
  Card,
  CardBadge,
  CardBadgeFlame,
  CardBook,
  CardCollection,
  CardImage,
  CardPlain,
  CardRecipe,
  CardVideo,
  CardWorkout,
} from './Card';

import {
  DashboardCarousel,
  DashboardCarouselLinks,
  DashboardNutritionHack,
  DashboardNutritionContainer,
  DashboardNutritionInspiration,
  DashboardNutritionUpgrade,
  DashboardNutritionMealPlan,
  DashboardWorkoutHack,
  DashboardWorkoutContainer,
  DashboardWorkoutInspiration,
  DashboardWorkoutUpgrade,
} from './Dashboard';

import {
  FormCheckboxToggle,
  FormErrors,
  FormFieldset,
  FormGroupRow,
  FormInput,
  FormLabel,
  FormLabelCheckbox,
  FormRadio,
  FormRadioList,
  FormSelect,
  FormSelectDate,
  FormTextarea,
} from './FormElements';

import {
  IngredientsCheck,
  IngredientsChecklist,
  IngredientsList,
} from './Ingredients';

import {
  MealPlanAside,
  MealPlanCard,
  MealPlanCookMore,
  MealPlanCreateButton,
  MealPlanDayCalories,
  MealPlanDayIcon,
  MealPlanDays,
  MealPlanHelp,
  MealPlanNav,
  MealPlanPrint,
  MealPlans,
  MealPlanRecipe,
  MealPlanRecipeSwap,
  MealPlanServes,
  MealPlanSwap,
  MealPlanSwaps,
  MealPlanTags,
} from './MealPlan';

import {
  NavChildren,
  NavDropdown,
  NavFullscreen,
  NavItem,
  NavLogo,
  NavMain,
  NavMobileSidebar,
  NavPage,
  NavPlain,
  NavProductTitle,
  NavSub,
} from './Nav';

import {
  ProgramNotStarted,
  ProgramProfile,
  ProgramRestartModal,
  ProgramStartModal,
  ProgramWeekMealPlan,
  ProgramWeekOverview,
  ProgramWeekVideos,
  ProgramWeekWorkouts,
} from './Program';

import {
  ProfileActions,
  ProfileBilling,
  ProfileContainer,
  ProfileFields,
  ProfileFieldsCancel,
  ProfileFieldsDowngrade,
  ProfileFieldsMore,
  ProfileFieldsNutrition,
  ProfileFieldsPassword,
  ProfileFieldsWorkout,
} from './Profile';

import {
  RecipeDetail,
  RecipeOptions,
  RecipePreview,
  RecipeRow,
} from './Recipe';

import {
  SearchFilter,
  SearchFilterBadge,
  SearchFilterRecipes,
  SearchFilterResults,
  SearchFilterWorkouts,
  SearchFilterVideos,
  SearchForm,
  SearchOrder,
  SearchResults,
} from './Search';

import {
  SignupAside,
  SignupFooter,
  SignupFormBilling,
  SignupFormPersonal,
  SignupIcon,
  SignupPrice,
  SignupSelectorProgram,
  SignupSelectorWeekly,
  SignupTileBundle,
  SignupTileProgram,
  SignupTileWeekly,
  SignupVerifying,
} from './Signup';

import {
  SpeechBubble,
  SpeechBubbleNutrition,
  SpeechBubbleWorkout,
} from './SpeechBubble';

import {
  VideoPlayer,
  VideoPlayerResumable,
  VideoPlaylist,
  VideoProgress,
} from './Video';

import {
  WelcomeStepActions,
  WelcomeStepBundle,
  WelcomeStepNutrition,
  WelcomeStepPassword,
  WelcomeStepProfile,
  WelcomeStepPrograms,
  WelcomeStepWorkout,
} from './WelcomeSteps';

import {
  WorkoutCaloriesBurnt,
  WorkoutIntro,
  WorkoutList,
  WorkoutMeta,
  WorkoutRatings,
  WorkoutSection,
} from './Workout';

import {
  WorkoutPlayerContextItem,
  WorkoutPlayerContextPanel,
  WorkoutPlayerControls,
  WorkoutPlayerCountdown,
  WorkoutPlayerFinished,
  WorkoutPlayerFinishModal,
  WorkoutPlayerHeader,
  WorkoutPlayerInstructions,
  WorkoutPlayerProgressBar,
  WorkoutPlayerSleeper,
  WorkoutPlayerTimer,
  WorkoutPlayerVideo,
} from './WorkoutPlayer';

export const Components = angular
  .module('App.Components', [])

  // Components
  .component('alert', Alert)
  .component('boxArrowRow', BoxArrowRow)
  .component('boxCorner', BoxCorner)
  .component('buttonBack', ButtonBack)
  .component('buttonBlock', ButtonBlock)
  .component('buttonFullWidth', ButtonFullWidth)
  .component('buttonLink', ButtonLink)
  .component('buttonPlay', ButtonPlay)
  .component('buttonPrimary', ButtonPrimary)
  .component('buttonPrint', ButtonPrint)
  .component('card', Card)
  .component('cardBadge', CardBadge)
  .component('cardBadgeFlame', CardBadgeFlame)
  .component('cardBook', CardBook)
  .component('cardCollection', CardCollection)
  .component('cardImage', CardImage)
  .component('cardPlain', CardPlain)
  .component('cardRecipe', CardRecipe)
  .component('cardVideo', CardVideo)
  .component('cardWorkout', CardWorkout)
  .component('carousel', Carousel)
  .component('collectionHeader', CollectionHeader)
  .component('completer', Completer)
  .component('completerNotification', CompleterNotification)
  .component('currentDay', CurrentDay)
  .component('dashboardCarousel', DashboardCarousel)
  .component('dashboardNutritionHack', DashboardNutritionHack)
  .component('dashboardNutritionContainer', DashboardNutritionContainer)
  .component('dashboardNutritionInspiration', DashboardNutritionInspiration)
  .component('dashboardNutritionUpgrade', DashboardNutritionUpgrade)
  .component('dashboardNutritionMealPlan', DashboardNutritionMealPlan)
  .component('dashboardWorkoutHack', DashboardWorkoutHack)
  .component('dashboardWorkoutContainer', DashboardWorkoutContainer)
  .component('dashboardWorkoutInspiration', DashboardWorkoutInspiration)
  .component('dashboardWorkoutUpgrade', DashboardWorkoutUpgrade)
  .component('dividerHr', DividerHr)
  .component('dividerZigZag', DividerZigZag)
  .component('exercise', Exercise)
  .component('exerciseSet', ExerciseSet)
  .component('favouriteButton', FavouriteButton)
  .component('favouriteNoResult', FavouriteNoResult)
  .component('footerDashboard', FooterDashboard)
  .component('footerMain', FooterMain)
  .component('formCheckboxToggle', FormCheckboxToggle)
  .component('formErrors', FormErrors)
  .component('formFieldset', FormFieldset)
  .component('formGroupRow', FormGroupRow)
  .component('formInput', FormInput)
  .component('formLabel', FormLabel)
  .component('formLabelCheckbox', FormLabelCheckbox)
  .component('formRadio', FormRadio)
  .component('formRadioList', FormRadioList)
  .component('formSelect', FormSelect)
  .component('formSelectDate', FormSelectDate)
  .component('formTextarea', FormTextarea)
  .component('formFeedback', FormFeedback)
  .component('formLogin', FormLogin)
  .component('formResetPassword', FormResetPassword)
  .component('formReview', FormReview)
  .component('imageBackground', ImageBackground)
  .component('imageCircle', ImageCircle)
  .component('ingredientsList', IngredientsList)
  .component('ingredientsCheck', IngredientsCheck)
  .component('ingredientsChecklist', IngredientsChecklist)
  .component('mealPlanAside', MealPlanAside)
  .component('mealPlanCard', MealPlanCard)
  .component('mealPlanCookMore', MealPlanCookMore)
  .component('mealPlanCreateButton', MealPlanCreateButton)
  .component('mealPlanDayCalories', MealPlanDayCalories)
  .component('mealPlanDayIcon', MealPlanDayIcon)
  .component('mealPlanDays', MealPlanDays)
  .component('mealPlanHelp', MealPlanHelp)
  .component('mealPlanNav', MealPlanNav)
  .component('mealPlanPrint', MealPlanPrint)
  .component('mealPlanRecipe', MealPlanRecipe)
  .component('mealPlanRecipeSwap', MealPlanRecipeSwap)
  .component('mealPlanServes', MealPlanServes)
  .component('mealPlanSwap', MealPlanSwap)
  .component('mealPlanSwaps', MealPlanSwaps)
  .component('mealPlanTags', MealPlanTags)
  .component('modal', Modal)
  .component('modalPopup', ModalPopup)
  .component('modalUpgrade', ModalUpgrade)
  .component('navChildren', NavChildren)
  .component('navDropdown', NavDropdown)
  .component('navFullscreen', NavFullscreen)
  .component('navItem', NavItem)
  .component('navLogo', NavLogo)
  .component('navMain', NavMain)
  .component('navPage', NavPage)
  .component('navPlain', NavPlain)
  .component('navProductTitle', NavProductTitle)
  .component('navMobileSidebar', NavMobileSidebar)
  .component('navSub', NavSub)
  .component('nutritionInformation', NutritionInformation)
  .component('paginationRow', PaginationRow)
  .component('profileActions', ProfileActions)
  .component('profileBilling', ProfileBilling)
  .component('profileContainer', ProfileContainer)
  .component('profileFields', ProfileFields)
  .component('profileFieldsCancel', ProfileFieldsCancel)
  .component('profileFieldsDowngrade', ProfileFieldsDowngrade)
  .component('profileFieldsMore', ProfileFieldsMore)
  .component('profileFieldsNutrition', ProfileFieldsNutrition)
  .component('profileFieldsPassword', ProfileFieldsPassword)
  .component('profileFieldsWorkout', ProfileFieldsWorkout)
  .component('progressBadge', ProgressBadge)
  .component('progressBar', ProgressBar)
  .component('programNotStarted', ProgramNotStarted)
  .component('programRestartModal', ProgramRestartModal)
  .component('programStartModal', ProgramStartModal)
  .component('programWeekMealPlan', ProgramWeekMealPlan)
  .component('programWeekOverview', ProgramWeekOverview)
  .component('programWeekVideos', ProgramWeekVideos)
  .component('programWeekWorkouts', ProgramWeekWorkouts)
  .component('ratingStars', RatingStars)
  .component('recipeDetail', RecipeDetail)
  .component('recipeOptions', RecipeOptions)
  .component('recipePreview', RecipePreview)
  .component('recipeRow', RecipeRow)
  .component('review', Review)
  .component('reviewReply', ReviewReply)
  .component('searchFilter', SearchFilter)
  .component('searchFilterBadge', SearchFilterBadge)
  .component('searchFilterRecipes', SearchFilterRecipes)
  .component('searchFilterResults', SearchFilterResults)
  .component('searchFilterWorkouts', SearchFilterWorkouts)
  .component('searchFilterVideos', SearchFilterVideos)
  .component('searchForm', SearchForm)
  .component('searchOrder', SearchOrder)
  .component('searchResults', SearchResults)
  .component('signupAside', SignupAside)
  .component('signupFooter', SignupFooter)
  .component('signupFormBilling', SignupFormBilling)
  .component('signupFormPersonal', SignupFormPersonal)
  .component('signupIcon', SignupIcon)
  .component('signupPrice', SignupPrice)
  .component('signupSelectorProgram', SignupSelectorProgram)
  .component('signupSelectorWeekly', SignupSelectorWeekly)
  .component('signupTileProgram', SignupTileProgram)
  .component('signupTileWeekly', SignupTileWeekly)
  .component('signupVerifying', SignupVerifying)
  .component('speechBubble', SpeechBubble)
  .component('speechBubbleNutrition', SpeechBubbleNutrition)
  .component('speechBubbleWorkout', SpeechBubbleWorkout)
  .component('spinner', Spinner)
  .component('termsConditions', TermsConditions)
  .component('videoPlayer', VideoPlayer)
  .component('videoPlayerResumable', VideoPlayerResumable)
  .component('videoPlaylist', VideoPlaylist)
  .component('videoProgress', VideoProgress)
  .component('welcomeStepActions', WelcomeStepActions)
  .component('welcomeStepBundle', WelcomeStepBundle)
  .component('welcomeStepNutrition', WelcomeStepNutrition)
  .component('welcomeStepPassword', WelcomeStepPassword)
  .component('welcomeStepProfile', WelcomeStepProfile)
  .component('welcomeStepPrograms', WelcomeStepPrograms)
  .component('welcomeStepWorkout', WelcomeStepWorkout)
  .component('workoutCaloriesBurnt', WorkoutCaloriesBurnt)
  .component('workoutIntro', WorkoutIntro)
  .component('workoutList', WorkoutList)
  .component('workoutMeta', WorkoutMeta)
  .component('workoutRatings', WorkoutRatings)
  .component('workoutSection', WorkoutSection)
  .component('workoutPlayerContextPanel', WorkoutPlayerContextPanel)
  .component('workoutPlayerContextItem', WorkoutPlayerContextItem)
  .component('workoutPlayerControls', WorkoutPlayerControls)
  .component('workoutPlayerCountdown', WorkoutPlayerCountdown)
  .component('workoutPlayerFinished', WorkoutPlayerFinished)
  .component('workoutPlayerFinishModal', WorkoutPlayerFinishModal)
  .component('workoutPlayerHeader', WorkoutPlayerHeader)
  .component('workoutPlayerInstructions', WorkoutPlayerInstructions)
  .component('workoutPlayerProgressBar', WorkoutPlayerProgressBar)
  .component('workoutPlayerSleeper', WorkoutPlayerSleeper)
  .component('workoutPlayerTimer', WorkoutPlayerTimer)

  // Directives
  .directive('nutritionBmi', NutritionBmi)
  .directive('scrollTopOnChange', ScrollTopOnChange)
  .directive('creditCardNumber', CreditCardNumber)
  .directive('creditCardDate', CreditCardDate)
  .directive('workoutPlayerVideo', WorkoutPlayerVideo).name;



// WEBPACK FOOTER //
// ./src/components/index.js